import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.scss";

interface ISidebarLink {
  label: string;
  path: string;
}

interface ISidebarSection {
  title: string;
  icon: string;
  links: ISidebarLink[];
}

// Define which paths should be disabled
const disabledPaths = [
  "/bewerber",
  "/neuer-bewerber",
  "/neue-buchung",
  "/profile",
];

const sections: ISidebarSection[] = [
  {
    title: "Klienten-Verwaltung",
    icon: "fa-address-book",
    links: [{ label: "Klientenübersicht", path: "/leadOverview" }],
  },
  {
    title: "Bewerber-Verwaltung",
    icon: "fa-user-friends",
    links: [
      { label: "Bewerber", path: "/bewerber" },
      { label: "Neuer Bewerber", path: "/neuer-bewerber" },
    ],
  },
  {
    title: "Buchungsverwaltung",
    icon: "fa-calendar",
    links: [
      { label: "Buchungen", path: "/buchungen" },
      { label: "Neue Buchung", path: "/neue-buchung" },
    ],
  },
  {
    title: "Aufgaben",
    icon: "fa-tasks",
    links: [{ label: "Aufgaben", path: "/task-management" }],
  },
  {
    title: "Einstellungen",
    icon: "fa-cog",
    links: [
      { label: "Profil", path: "/profile" },
      { label: "Einstellungen", path: "/email-settings" },
    ],
  },
];

const Sidebar: React.FC = () => {
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const initialExpandedSections = sections.reduce((acc, _, index) => {
    acc[index] = true;
    return acc;
  }, {} as { [key: number]: boolean });
  
  const [expandedSections, setExpandedSections] = useState<{ [key: number]: boolean }>(initialExpandedSections);
  
  const toggleSection = (index: number) => {
    setExpandedSections({
      ...expandedSections,
      [index]: !expandedSections[index],
    });
  };

  const handleTransitionEnd = () => {
    setShowContent(sidebarExpanded);
  };

  return (
    <aside
      className={`sidebar ${sidebarExpanded ? "expanded" : "collapsed"}`}
      onMouseEnter={() => setSidebarExpanded(true)}
      onMouseLeave={() => {
        setSidebarExpanded(false);
        setShowContent(false);
      }}
      onTransitionEnd={handleTransitionEnd}
    >
      {showContent && <h2>Pflege Sorgenlos</h2>}

      {sections.map((section, index) => (
        <div key={index} className="section">
          <div className="section-header" onClick={() => toggleSection(index)}>
            {showContent ? (
              <>
                <div className="group-info">
                  <i className={`fa ${section.icon}`}></i>
                  <span>{section.title}</span>
                </div>
                <i
                  className={`fa ${
                    expandedSections[index] ? "fa-chevron-up" : "fa-chevron-down"
                  }`}
                ></i>
              </>
            ) : (
              <i className={`fa ${section.icon}`}></i>
            )}
          </div>

          {showContent && expandedSections[index] && (
            <div className="section-content">
              {section.links.map((link, linkIndex) => {
                const isDisabled = disabledPaths.includes(link.path);
                return isDisabled ? (
                  <div key={linkIndex} className="nav-link disabled">
                    <span>{link.label}</span>
                    <i className="fa fa-lock lock-icon" aria-hidden="true"></i>
                  </div>
                ) : (
                  <NavLink
                    key={linkIndex}
                    to={link.path}
                    className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
                  >
                    {link.label}
                  </NavLink>
                );
              })}
            </div>
          )}
        </div>
      ))}
    </aside>
  );
};

export default Sidebar;

